module.exports = __webpack_public_path__ + "img/logo-light.ed831e4e.png";